import {Box, Stack, Tab, Tabs} from "@mui/material";
import PaymentRequestFilters from "./components/filters/PaymentRequestFilters";
import PaymentRequestTable from "./components/tables/PaymentRequestTable";
import OutstandingManagementTable from "./components/tables/OutstandingManagementTable";
import OutstandingManagementFilters from "./components/filters/OutstandingManagementFilters";
import {useTranslation} from "react-i18next";
import {useHasScope} from "../../../../../config/globalConfig";
import {useRef, useState} from "react";
import {SCOPE_CS_PAYMENT_REQUEST_VIEW} from "../../../utils/FinanceScope";
import {AgGridReact} from "ag-grid-react";

function PaymentRequest(props: { outstanding: boolean }) {

  const { t } = useTranslation("finance", { keyPrefix: "payments.payment-request" });

  const hasScope = useHasScope;
  const [tab, setTab] = useState<'planet' | 'carsharing'>('planet');


  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue === 0 ? 'planet' : 'carsharing');
  };

  const gridRef = useRef<AgGridReact>(null);

  return (
    <Stack direction={"column"} spacing={2} margin={"16px"}>
      {props.outstanding ? (
        <>
          <OutstandingManagementFilters />
          <OutstandingManagementTable />
        </>
      ) : (
        <>
          <PaymentRequestFilters currentTab={tab}/>
          <Box>
            <Tabs value={tab === 'planet' ? 0 : 1}
                  onChange={handleChange}>
              <Tab label={t("planetPaymentRequests")}/>
              {hasScope(SCOPE_CS_PAYMENT_REQUEST_VIEW) && <Tab label={t("carSharingPaymentRequests")}/>}
            </Tabs>
          </Box>

          <Box>
            {tab === 'planet' && <PaymentRequestTable />}
            {hasScope(SCOPE_CS_PAYMENT_REQUEST_VIEW) && (tab === 'carsharing' && <PaymentRequestTable carsharing={true}/>)}
          </Box>
        </>
      )}
    </Stack>
  );
}

export default PaymentRequest;
